import { z } from 'zod/v3';

export const MdmDeviceDTOSchema = z.object({
  externalId: z.string(),
  deviceName: z.string(),
  platform: z.string(),
  osVersion: z.string(),
  serialNumber: z.string(),
  model: z.string(),
  lastCheckIn: z.string(),
  enrolled: z.boolean(),
  diskEncryptionEnabled: z.boolean(),
  firewallEnabled: z.boolean().nullable(),
  compliant: z.boolean(),
  failingPoliciesCount: z.number(),
  userEmail: z.string().nullable(),
});

export const MdmComplianceSummaryDTOSchema = z.object({
  totalDevices: z.number(),
  enrolledDevices: z.number(),
  compliantDevices: z.number(),
  encryptedDevices: z.number(),
  complianceRate: z.number(),
  encryptionRate: z.number(),
});

export const MdmSyncResultDTOSchema = z.object({
  synced: z.number(),
  created: z.number(),
  updated: z.number(),
  errors: z.number(),
  /** Previously synced devices absent from this scan (retire candidates). */
  missing: z.number().optional(),
});

export const MdmScanResultDTOSchema = z.object({
  provider: z.enum(['MicrosoftIntune', 'FleetDM', 'JamfPro']),
  scannedAt: z.string(),
  summary: MdmComplianceSummaryDTOSchema,
  syncResult: MdmSyncResultDTOSchema,
  devices: z.array(MdmDeviceDTOSchema),
});

export const MdmConnectionDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  status: z.string(),
  metadata: z.record(z.unknown()).nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type MdmDeviceDTO = z.infer<typeof MdmDeviceDTOSchema>;
export type MdmComplianceSummaryDTO = z.infer<typeof MdmComplianceSummaryDTOSchema>;
export type MdmSyncResultDTO = z.infer<typeof MdmSyncResultDTOSchema>;
export type MdmScanResultDTO = z.infer<typeof MdmScanResultDTOSchema>;
export type MdmConnectionDTO = z.infer<typeof MdmConnectionDTOSchema>;
